import styled from "styled-components";
import { Avatar, Tabs } from "antd";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  overflow-x: hidden;
`;

export const InnerContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 25px;

  ${media.downTablet`
    width: 100%;
    max-width: ${CONTENT_WIDTH.pct};
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 25px;
    padding: 0 24px;
  `}

  ${media.downMobile`
    padding: 0 16px;
  `}
`;

export const MainButton = styled.a`
  display: flex;
  width: 547px;
  max-width: 100%;
  min-height: 44px;
  padding: 17px 30px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: #ed6928;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  box-sizing: border-box;

  ${media.downTablet`
    width: 100%;
  `}
`;

export const MainHeading = styled.h2`
  margin: 0px;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;

  ${media.downTablet`
    width: 100%;
    max-width: ${CONTENT_WIDTH.pct};
    margin: 0 auto;
    padding: 0 24px;
    box-sizing: border-box;
  `}

  ${media.downMobile`
    padding: 0 16px;
  `}
`;

export const AvatarWrapper = styled.div`
  text-align: center;
  margin-top: 25px;
  margin-bottom: 40px;
`;

export const StyledAvatar = styled(Avatar)`
  margin-left: -15px;
`;

export const AvatarText = styled.span`
  color: #999;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  padding-left: 12px;
`;

export const TabsWrapper = styled.div``;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    width: 400px;
    max-width: 100%;
    margin: 0 auto;
  }
  .ant-tabs-nav .ant-tabs-nav-wrap {
    justify-content: center;
  }
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    background: #ed6928 !important;
  }
  .ant-tabs-nav .ant-tabs-tab {
    border-radius: 8px !important;
    padding: 8px 60px !important;
    background: none;
    border: none;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #fff !important;
  }
  .ant-tabs-tab-btn {
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .ant-tabs-nav .ant-tabs-nav-list {
    padding: 8px;
    border-radius: 5px;
    background: #f5f5f5;
  }
  .ant-tabs-tabpane {
    width: 80%;
    max-width: 100%;
    margin: 0 auto;
    margin-top: 90px;
    margin-bottom: 50px;
    box-sizing: border-box;
  }

  ${media.downTablet`
    .ant-tabs-nav {
      width: 100%;
      max-width: 100%;
      padding: 0 24px;
      box-sizing: border-box;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      width: 100%;
      display: flex;
    }
    .ant-tabs-nav .ant-tabs-tab {
      flex: 1;
      justify-content: center;
      padding: 8px 12px !important;
      margin: 0 !important;
    }
    .ant-tabs-tabpane {
      width: 100%;
      max-width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
      padding: 0 24px;
      box-sizing: border-box;
    }
  `}

  ${media.downMobile`
    .ant-tabs-nav {
      padding-left: 16px;
      padding-right: 16px;
    }
    .ant-tabs-nav .ant-tabs-tab {
      padding: 8px 10px !important;
    }
    .ant-tabs-tab-btn {
      font-size: 14px;
    }
    .ant-tabs-tabpane {
      padding-left: 16px;
      padding-right: 16px;
    }
  `}
`;
